import actionTypes from './actionTypes';
import type { SiteLoadSuccessProps } from '../../types';

export default {
  [actionTypes.SITE_LOAD_SUCCESS]: (siteData: SiteLoadSuccessProps) => ({
    type: actionTypes.SITE_LOAD_SUCCESS,
    siteData,
  }),
};
